import videoPath from '../../../assets/video/full.mp4'
export default class Video {
  constructor() {
    //setup
    this.videoElement = document.createElement('video')
    this.videoControl = document.createElement('div')

    //Method
    this.createVideo()
  }
  createVideo() {
    //Video
    this.videoElement.className = 'showreel'
    this.videoElement.src = videoPath

    //VideoControls
    this.videoControl.className = 'videoControl'
    this.videoControl.innerText = 'skip'
    this.videoControl.addEventListener('click', e => {
      this.videoElement.pause()
      this.videoElement.style.display = 'none'
      this.videoControl.style.display = 'none'
      e.stopPropagation()
    })
  }
}
